core.directive('edmDateTimePicker', ['$parse',
    function($parse) {
        var definition = {
            require: 'ngModel',
            restrict: 'E',
            scope: {
                minDate: '=',
                maxDate: '=',
                ngModel: '=',
                showOnlyTime: '@?',
                showOnlyDate: '@?',
                name: '@',
                label: '@'
            },
            templateUrl: 'core/application/directive/edmDateTimePicker/template/edm-date-time-picker.html',
            link: function($scope, element, attr, ngModelCtrl) {
                $scope._showOnlyTime = _.isUndefined($scope.showOnlyTime) ? false : $scope.$eval($scope.showOnlyTime);
                $scope._showOnlyDate = _.isUndefined($scope.showOnlyDate) ? false : $scope.$eval($scope.showOnlyDate);
                $scope.onlyTime = '00:00';
                var currentTime;

                function getDateFromTime (timeStr) {
                    var d = new Date();
                    if(timeStr && timeStr.length === 5) {
                        d.setHours(timeStr.substr(0, 2), timeStr.substr(3, 2), 0 ,0);
                    } else {
                        return;
                        d.setHours(0, 0, 0 ,0);
                    }
                    return d;

                }

                $scope.$watch('showOnlyTime', function (newVal) {
                    $scope._showOnlyTime = _.isUndefined(newVal) ? false : $scope.$eval(newVal);
                });

                $scope.$watch('showOnlyDate', function (newVal) {
                    $scope._showOnlyDate = _.isUndefined(newVal) ? false : $scope.$eval(newVal);
                });

                $scope.$watch('minDate', function (newVal) {
                    if(newVal) {
                        $scope.minDateForDatePicker = new Date(newVal.getTime());
                        $scope.minDateForDatePicker.setHours(0,0,0,0);

                        if ($scope.ngModel && $scope.ngModel.getTime() < newVal.getTime()) {
                            $scope.ngModel = new Date(newVal.getTime());
                        }
                    }
                    $scope.validate();
                });

                $scope.$watch('maxDate', function (newVal) {
                    if(newVal) {
                        $scope.maxDateForDatePicker = new Date(newVal.getTime());
                        $scope.maxDateForDatePicker.setHours(0,0,0,0);

                        if ($scope.ngModel.getTime() > newVal.getTime()) {
                            $scope.ngModel = new Date(newVal.getTime());
                        }
                    }
                    $scope.validate();
                });

                $scope.$watch('ngModel', function (newVal) {
                    if(newVal) {
                        var hours = newVal.getHours();
                        hours = hours < 10 ? '0' + hours : hours;
                        var minutes = newVal.getMinutes();
                        minutes = minutes < 10 ? '0' + minutes : minutes;
                        $scope.onlyTime = hours + ':' + minutes;

                        $scope.onlyDate = new Date(newVal.getTime());
                        $scope.onlyDate.setHours(0,0,0,0);
                    }
                });

                ngModelCtrl.$validators.invalidDateTime = function () {
                    var date = $scope.ngModel;
                    if(date) {
                        date.setSeconds(0);
                        date = date.setMilliseconds(0);
                    }
                    var minDate = $scope.minDate;
                    if(minDate) {
                        minDate.setSeconds(0);
                        minDate = minDate.setMilliseconds(0);
                    }
                    var maxDate = $scope.maxDate;
                    if(maxDate) {
                        maxDate.setSeconds(0);
                        maxDate = maxDate.setMilliseconds(0);
                    }
                    if(!date || (minDate && (date < minDate)) || (maxDate && (date > maxDate)) || !$scope.onlyDate) {
                        element.find('.md-datepicker-input-container').addClass('md-datepicker-invalid');
                        element.find('md-input-container').addClass('md-input-invalid');
                        return false;
                    }

                    element.find('.md-datepicker-input-container').removeClass('md-datepicker-invalid');
                    element.find('md-input-container').removeClass('md-input-invalid');
                    return true;
                };

                $scope.validate = function () {
                    ngModelCtrl.$validate();
                };

                $scope.$watch(
                    function () {
                        if($scope.ngModel) {
                            return $scope.ngModel.getTime();
                        }
                    },
                    function () {
                        ngModelCtrl.$validate();
                    }
                );

                $scope.$watch(function () {
                    if($scope.onlyDate) {
                        return $scope.onlyDate.getTime();
                    }
                }, function (newVal) {
                    if($scope.onlyDate) {
                        $scope.ngModel = new Date($scope.onlyDate.getTime());
                        currentTime = getDateFromTime($scope.onlyTime);
                        if(currentTime) {
                            $scope.ngModel.setHours(currentTime.getHours(), currentTime.getMinutes(), 0, 0);
                        } else {
                            $scope.ngModel.setHours(0, 0, 0, 0);
                        }
                    }
                });

                $scope.$watch('onlyTime', function(modelValue, old){
                    var val = modelValue, o = old;

                    if(!val) return;

                    if(val && val.match(/^[0-9]{2}:[0-9]{2}$/)) {

                        //W meedym z edmem należy zaokrąglać do 5min
                        if(!val.match(/^[0-9]{2}:[0-9]{1}[0,5]{1}$/)) {
                            var lastNum = val.substr(4, 5);
                            lastNum = parseInt(val.substr(4,5) < 5 ? '0' : '5');

                            val = val.substr(0, 4) + lastNum;
                        }
                    } else {
                        if(val.length === 4 && val[val.length-1] == ':') {
                            val = val.substr(0, 3);
                        }

                        if(val.length === 5) {
                            val = '00:00';
                        }
                    }

                    if(val.length === 2 && (!o || o.length < 2)) {
                        if(val[1] === ':') {
                            val = '0' + val;
                        } else
                            val = val + ':';
                    }

                    if(val.length > 5) {
                        val = val.substr(0, 5);
                    }

                    if(val.length === 1 && (!o || o.length < 1)) {
                        if(val > 2) {
                            val = '0' + val;
                        }
                    }

                    if(val.length === 5) {
                        var split = val.split(':');
                        var hours = split[0];
                        var minutes = split[1];
                        if(hours > 24) {
                            hours = '00';
                        }
                        if(minutes > 59) {
                            minutes = '00';
                        }
                        val = hours + ':' + minutes;
                    }

                    $scope.onlyTime = val;

                    currentTime = getDateFromTime(val);
                    if(currentTime && $scope.onlyDate) {
                        var date = new Date($scope.onlyDate.getTime());
                        date.setHours(currentTime.getHours(), currentTime.getMinutes(), 0, 0)
                        $scope.ngModel = date;
                    }



                });


            }
        };

        return definition;
    }
]);